module.exports = __webpack_public_path__ + "assets/project.be4a4e28.svg";